import * as THREE from 'three';

export interface LookRotation {
  pitch: number;
  yaw: number;
}

export interface MovementBoundsXZ {
  minX: number;
  maxX: number;
  minZ: number;
  maxZ: number;
}

export function movementBoundsAroundPoints(
  points: Array<[number, number, number]>,
  margin: number,
): MovementBoundsXZ {
  const xs = points.map((point) => point[0]);
  const zs = points.map((point) => point[2]);
  return {
    minX: Math.min(...xs) - margin,
    maxX: Math.max(...xs) + margin,
    minZ: Math.min(...zs) - margin,
    maxZ: Math.max(...zs) + margin,
  };
}

export function resolveBoundedMovementXZ(
  current: [number, number, number],
  delta: [number, number, number],
  bounds: MovementBoundsXZ,
): [number, number, number] {
  return [
    THREE.MathUtils.clamp(current[0] + delta[0], bounds.minX, bounds.maxX),
    current[1],
    THREE.MathUtils.clamp(current[2] + delta[2], bounds.minZ, bounds.maxZ),
  ];
}

export function conversationCameraPosition(
  npcPosition: [number, number, number],
  facingY: number,
  distance: number,
): [number, number, number] {
  const cameraYaw = facingY + Math.PI;
  return [
    npcPosition[0] + Math.sin(cameraYaw) * distance,
    npcPosition[1],
    npcPosition[2] + Math.cos(cameraYaw) * distance,
  ];
}

export function applyLookDelta(
  rotation: LookRotation,
  deltaX: number,
  deltaY: number,
  sensitivity: number,
  pitchMin: number,
  pitchMax: number,
  yawCenter: number | null,
  maxYaw: number,
): LookRotation {
  const proposedYaw = rotation.yaw - deltaX * sensitivity;
  const yaw = yawCenter === null
    ? proposedYaw
    : THREE.MathUtils.clamp(proposedYaw, yawCenter - maxYaw, yawCenter + maxYaw);
  return {
    pitch: THREE.MathUtils.clamp(rotation.pitch - deltaY * sensitivity, pitchMin, pitchMax),
    yaw,
  };
}
